import { GET_LEADS_CAP_DERIVATIVES_REQUEST, GET_LEADS_CAP_DERIVATIVES_REQUEST_SUCCESS, GET_LEADS_CAP_DERIVATIVES_REQUEST_FAILURE } from '../../constants/cap.constants';

export const getLeadsCapDerivativesRequest = variant_id => ({ type: GET_LEADS_CAP_DERIVATIVES_REQUEST, variant_id });
export const getLeadsCapDerivativesRequestSuccess = payload => ({ type: GET_LEADS_CAP_DERIVATIVES_REQUEST_SUCCESS, payload });
export const getLeadsCapDerivativesRequestFailure = error => ({ type: GET_LEADS_CAP_DERIVATIVES_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/cap_actions/get_cap_derivatives.actions.js